/**
 * @documental
 * @export Placeholder
 * @name
 * Radio.Placeholder
 */

import { FC } from "react";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";
import styles from "./styles.module.scss";
import { SharedRadioPlaceholder } from "./SharedRadioPlaceholder";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `Radio` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.RadioPlaceholder, "radio", "placeholder"],
    testIdPrefix: "radio",
  });

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <SharedRadioPlaceholder />
    </InputContainerPlaceholder>
  );
};
